export default "__VITE_ASSET__svBCbpRw__"